import PerksMainPage from "./pages/PerksMainPage";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <PerksMainPage />
      </header>
    </div>
  );
}

export default App;
